import "./styles/user.less";
import React from "react";
import { connect } from "dva";
import { Layout } from "antd";
import { Switch } from "dva/router";
import $$ from "cmn-utils";
const { Content } = Layout;

@connect()
export default class UserLayout extends React.PureComponent {
  render() {
    const { routerData } = this.props;
    const { childRoutes } = routerData;

    if (window.location.href.indexOf("qrresult=") > 0) {
      let sn = decodeURIComponent(window.location.href).split("sn=")[1].split("#")[0];
      $$.setStore("bind_sn", sn);
      // window.history.go(-1);
      window.location.href = window.contextPath + '#/sign/wechat';
    }

    return (
      <Layout className="full-layout user-layout fixed">
        <Content>
          <Switch>{childRoutes}</Switch>
        </Content>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/UserLayout.js